import React from 'react'

interface MBatteryIconProps {
  jd?: any
}

const BatteryIcon: React.FC<MBatteryIconProps> = ({ jd = 50 }) => {
  return (
    <div className='BatteryIcon'>
      <img src='/assets/image/Battery.svg' style={{ margin: '8px 0' }} />
      <div className='allJd'>
        <div className='BatteryJd' style={{ width: `${jd}%` }}></div>
      </div>
    </div>
  )
}

export default BatteryIcon
